import React, { useEffect, useMemo, useState } from "react";
import coin from "../../assets/img/icons/coin.avif";

const PurchaseConfirmation = ({ couponData, onClose }) => {
    const coupon_data = couponData?.couponData || {};
    const [price, setprice] = useState(coupon_data?.price);
    const [activeSection, setActiveSection] = useState("how-to-redeem");

    const voucher_code = useMemo(() => {
        const raw = couponData?.voucher_code;
        if (Array.isArray(raw)) return raw.filter(Boolean);
        if (typeof raw === "string") {
            return raw
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean);
        }
        return [];
    }, [couponData?.voucher_code]);

    const voucher_pin = useMemo(() => {
        const raw = couponData?.voucher_pin;
        if (Array.isArray(raw)) return raw.filter(Boolean);
        if (typeof raw === "string") {
            return raw
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean);
        }
        return [];
    }, [couponData?.voucher_pin]);

    useEffect(() => {
        setprice(coupon_data?.price);
    }, [coupon_data?.price]);

    useEffect(() => {
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = previousOverflow || "auto";
        };
    }, []);

    function copiedBtn(copy_btn) {
        if (!copy_btn) return;
        let tooltip_text = document.createElement("span");
        tooltip_text.innerText = "Copied!";
        tooltip_text.style.position = "absolute";
        tooltip_text.style.background = "#e71a1a";
        tooltip_text.style.color = "#fff";
        tooltip_text.style.padding = "2px 8px";
        tooltip_text.style.borderRadius = "4px";
        tooltip_text.style.fontSize = "12px";
        tooltip_text.style.top = "-28px";
        tooltip_text.style.right = "0";
        tooltip_text.style.zIndex = "9000";
        tooltip_text.style.textTransform = "none";
        tooltip_text.className = "copied-tooltip_text";

        copy_btn.parentElement.style.position = "relative";
        copy_btn.parentElement.appendChild(tooltip_text);

        setTimeout(() => {
            tooltip_text.remove();
        }, 3000);
    }

    function copy_btn(id, event) {
        const ID = !id ? "invite-code0" : id;
        const copy_text = document.getElementById(ID);
        if (!copy_text) return;
        const text = copy_text.textContent.trim();
        navigator.clipboard
            .writeText(text)
            .then(() => copiedBtn(event?.target))
            .catch((err) => {
                console.log("error", err);
            });
    }

    function copy_code_redirect(event) {
        copy_btn("invite-code0", event);
        if (coupon_data?.redeem_link) {
            window.open(coupon_data.redeem_link, "_blank");
        }
    }

    return (
        <>
            <style>
                {`
                .purchase-confirm-modal {
                    position: fixed;
                    inset: 0;
                    z-index: 1300;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(0, 0, 0, 0.75);
                    padding: 16px;
                }
                .purchase-confirm-card {
                    width: 100%;
                    max-width: 520px;
                    max-height: 90vh;
                    overflow-y: auto;
                    background: #161616;
                    border: 1px solid #38363e;
                    border-radius: 8px;
                    color: #fff;
                    padding: 20px;
                    position: relative;
                }
                .purchase-confirm-close {
                    position: absolute;
                    right: 12px;
                    top: 10px;
                    background: transparent;
                    border: 0;
                    color: #fff;
                    font-size: 20px;
                    cursor: pointer;
                }
                `}
            </style>
            <div
                className="purchase-confirm-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="purchase-confirm-title"
                onClick={(event) => {
                    if (event.target === event.currentTarget) {
                        onClose();
                    }
                }}
            >
                <div className="purchase-confirm-card">
                    <button className="purchase-confirm-close" onClick={onClose} aria-label="Close">
                        x
                    </button>
                    <div className="row container-fluid">
                        <div className="col-12">
                            <div className="coupon-banner w-100">
                                <img
                                    src={`${coupon_data?.thumb_img || ""}`}
                                    onError={(e) => {
                                        e.currentTarget.onerror = null;
                                        e.currentTarget.src = "/assets/img/coupon_fallback.jpg";
                                    }}
                                    alt="Coupon Banner"
                                    className="img-fluid w-80"
                                />
                            </div><br/>
                        </div>
                        <div className="col-12">
                            <h5 id="purchase-confirm-title" className="fw-bold mb-0">
                                {coupon_data?.title}
                            </h5>
                        </div>
                    </div>

                    <div className="container-fluid mt-3">
                        {voucher_code.length > 0 ? (
                            voucher_code.map((data, index) => (
                                <React.Fragment key={`voucher-code-${index}`}>
                                    <label className="d-flex" style={{color:'#ff801e'}}>
                                        {voucher_code.length === 1 ? "Code :" : `Code ${index + 1}`}
                                    </label><br/>
                                    <div
                                        className="card mb-2"
                                        style={{ backgroundColor: "#000000", padding: "20px", borderRadius: "8px", cursor: "pointer" }}
                                        onClick={(event) => copy_btn(`invite-code${index}`, event)}
                                    >
                                        <div className="amount-area d-flex justify-content-between" id={`invite-code${index}`}>
                                            <span className="title" style={{color:'#fff'}}>{data}</span>
                                            <button className="color-base title" style={{ background: "none", border: "none" }}>
                                                <i className="fa-solid fa-copy fa-lg" style={{color:'#ff810e'}}></i>
                                            </button>
                                        </div>
                                    </div>
                                    {voucher_pin[index] ? (
                                        <>
                                            <label className="d-flex text-white">
                                                {voucher_pin.length === 1 ? "Pin" : `Pin ${index + 1}`}
                                            </label>
                                            <div
                                                className="card mb-2"
                                                style={{ backgroundColor: "#383737", padding: "20px", borderRadius: "8px", cursor: "pointer" }}
                                                onClick={(event) => copy_btn(`invite-pin${index}`, event)}
                                            >
                                                <div className="amount-area d-flex justify-content-between" id={`invite-pin${index}`}>
                                                    <span className="title">{voucher_pin[index]}</span>
                                                    <button className="color-base title" style={{ background: "none", border: "none" }}>
                                                        <i className="fa-solid fa-copy fa-lg"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    ) : null}
                                </React.Fragment>
                            ))
                        ) : (
                            <div className="card" style={{ backgroundColor: "#383737", padding: "20px", borderRadius: "8px", cursor: "pointer" }}>
                                <div className="amount-area d-flex justify-content-center" id="invite-code">
                                    <span className="title text-center" style={{ color: "#ff810e" }}>
                                        {coupon_data?.purchase_stat || "Processing"}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="container-fluid mt-3" style={{ textAlign: "left" }}>
                        <h5 className="fw-bold mb-2" id="dir-denom-value">
                            Price: {price} <img src={coin} style={{ width: "20px", height: "25px", paddingBottom: "5px" }} alt="" />
                        </h5>
                        <hr />
                        <p className="">{coupon_data?.sub_title}</p>

                        <div className="ticket-accordion accordion-items" style={{ padding: "15px", background: "#1d1d1d", borderRadius: "8px" }}>
                            <h2 className="accordion-headers" id="heading-how-to-redeem-purchase">
                                <button
                                    className={`accordion-buttons d-flex justify-content-between align-items-center text-wrap w-100 ${activeSection === "how-to-redeem" ? "expanded" : ""}`}
                                    type="button"
                                    onClick={() => setActiveSection(activeSection === "how-to-redeem" ? "" : "how-to-redeem")}
                                    style={{ background: "transparent", border: 0, color: "#fff", fontWeight: 600 }}
                                >
                                    <span className="me-2" style={{ fontSize: "18px" }}>How to Redeem</span>
                                    <i className="fa fa-angle-down"></i>
                                </button>
                            </h2>
                            {activeSection === "how-to-redeem" ? (
                                <div className="accordion-body" style={{ fontSize: "14px", marginTop: "10px" }}>
                                    <div dangerouslySetInnerHTML={{ __html: coupon_data?.how_to_redeem }} />
                                </div>
                            ) : null}
                        </div>

                        {coupon_data?.redeem_link ? (
                            <center className="mt-3">
                                <button
                                    className="btn btn-warning"
                                    style={{ color: "#fff", background:'#ff810e',border: '1px solid #ff810e' }}
                                    onClick={(event) => copy_code_redirect(event)}
                                >
                                    Copy Code & Redirect <i className="fa fa-arrow-right"></i>
                                </button>
                            </center>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PurchaseConfirmation;
